import { Button } from '@/components/shared/Button';

import cn from './styles.module.sass';

export const ErrorContent = () => {
    const handleReloadPage = () => {
        window.location.reload();
    };

    return (
        <div className={cn.container}>
            <div className={cn.iconWrapper}>
                <img src="/images/main/error.svg" alt="" />
            </div>
            <h2>Что-то пошло не так</h2>
            <p>Попробуй еще раз</p>
            <Button onClick={handleReloadPage}>Обновить страницу</Button>
        </div>
    );
};
